import React from 'react';
import QRCode from '../../../containers/CasinoversePage/assets/QR-500.png';
import GetAppButton from './GetAppButton';
import TickImage from './assets/Image-check-white.png';
import './CVPromoSection.scss';

const CVPromoSection = props => {
  return (
    <div className="cv-landing-promo-section-wrapper">
      <div className="cv-landing-promo-section">
        <h1>FOR EVEN MORE FUN...</h1>
        <h2>Download our new Casinoverse Mobile App</h2>
        <div className="cv-landing-promo-section-mobile" />
        <div className="cv-landing-promo-details">
          <div className="cv-landing-promo-list-section ">
            <div className="cv-landing-promo-list-content">
              <div className="cv-landing-promo-list-content-image">
                <img src={TickImage} alt="" />
              </div>
              <div className="cv-landing-promo-list-content-text">
                <p>
                  Play on your phone anytime, anywhere for winning on the go
                </p>
              </div>
            </div>
            <div className="cv-landing-promo-list-content">
              <div className="cv-landing-promo-list-content-image">
                <img src={TickImage} alt="" />
              </div>
              <div className="cv-landing-promo-list-content-text">
                <p>More opportunities to earn WScore for bigger rewards</p>
              </div>
            </div>
            <div className="cv-landing-promo-list-content">
              <div className="cv-landing-promo-list-content-image">
                <img src={TickImage} alt="" />
              </div>
              <div className="cv-landing-promo-list-content-text">
                <p>Daily challenges, unique Quests, and bonus Mini-games</p>
              </div>
            </div>
          </div>
          <div className="cv-landing-qr-section">
            <img src={QRCode} alt="qr for app download" />
            <h6>Get App</h6>
          </div>
          <div className="cv-landing-app-section">
            <GetAppButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CVPromoSection;
